var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchivedTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1782_38082)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 78,
    height: 78,
    rx: 20,
    fill: "#A2AD1F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.9987 40.334C56.0979 40.334 53.2623 41.1942 50.8503 42.8058C48.4384 44.4174 46.5586 46.708 45.4485 49.388C44.3384 52.0679 44.0479 55.0169 44.6139 57.862C45.1798 60.707 46.5766 63.3204 48.6278 65.3716C50.679 67.4227 53.2923 68.8196 56.1374 69.3855C58.9824 69.9514 61.9314 69.661 64.6114 68.5509C67.2914 67.4408 69.582 65.5609 71.1936 63.149C72.8052 60.7371 73.6654 57.9014 73.6654 55.0007C73.6608 51.1122 72.1141 47.3844 69.3645 44.6348C66.615 41.8853 62.8871 40.3386 58.9987 40.334ZM63.9414 59.9433C63.6913 60.1933 63.3523 60.3337 62.9987 60.3337C62.6452 60.3337 62.3061 60.1933 62.056 59.9433L58.056 55.9433C57.806 55.6933 57.6654 55.3542 57.6654 55.0007V47.0007C57.6654 46.647 57.8058 46.3079 58.0559 46.0578C58.3059 45.8078 58.6451 45.6673 58.9987 45.6673C59.3523 45.6673 59.6915 45.8078 59.9415 46.0578C60.1916 46.3079 60.332 46.647 60.332 47.0007V54.4487L63.9414 58.058C64.1913 58.308 64.3318 58.6471 64.3318 59.0007C64.3318 59.3542 64.1913 59.6933 63.9414 59.9433Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1782_38082",
    x: 0,
    y: 0,
    width: 118,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368542 0 0 0 0 0.519173 0 0 0 0 0.7625 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1782_38082"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1782_38082",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivedTickets);
export default __webpack_public_path__ + "static/media/archived_tickets.a699e5649d6510df11c547bd6acd3d70.svg";
export { ForwardRef as ReactComponent };